import ChallengeNotification from './ChallengeNotification.vue';

// @ts-ignore
ChallengeNotification.install = (Vue) => {
  Vue.component((ChallengeNotification as any).options.name, ChallengeNotification);
};

export default ChallengeNotification;
